"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHubClient = exports.getDeLabClient = void 0;
/* eslint-disable import/no-extraneous-dependencies */
const ton_1 = require("@ton/ton");
const getDeLabClient = () => new ton_1.TonClient4({ endpoint: 'https://tonclient4.delab.team' });
exports.getDeLabClient = getDeLabClient;
const getHubClient = () => new ton_1.TonClient4({ endpoint: 'https://mainnet-v4.tonhubapi.com' });
exports.getHubClient = getHubClient;
